import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useModal } from 'react-modal-hook'
import '../../styles/Profile.css'
import Modal from '../../components/Modal/Modal'
import NeoButton from '../../components/NeoButton/NeoButton'
import AuthService from '../../services/auth.service'
import { profileImageSelector, profileSelector } from '../../selectors'
import Loading from 'custom/assets/loaders/Loading'
import LayoutWithOutAccountCard from '../../layout/Layout/layout-without-card'
import { useHistory } from 'react-router-dom'
import DeleteIcon from 'custom/assets/icons/delete.svg'
import UploadIcon from 'custom/assets/icons/upload.svg'
import {MENU_SIDEBAR_KEYS, DIALOG_KEYS, PROFILE_KEYS } from '../../utils/translation-constants'
import UserImageIcon from 'custom/assets/dashboard/dummy-user.png'
import config from 'custom/config/environment'

export default function Profile() {
  const history = useHistory()
  const { t } = useTranslation()
  const profileImage = useSelector(profileImageSelector)
  const profileDetails = useSelector(profileSelector)
  const [profile, setProfile] = useState({})
  const [stage, setStage] = useState(1)
  const inputFile = useRef()
  //const [image, setImage] = useState('')
  const [imgLocation, setImgLocation] = useState('')
  const [imageData, setImageData] = useState('')
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)


  const [showSuccessModal, hideSuccessModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>{message}</h6>
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={t(DIALOG_KEYS.CLOSE)}
              onClick={() => {
                hideSuccessModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )

  const [deleteModal, hideDeleteModal] = useModal(
    () => (
      <Modal>
        <h6>{t(DIALOG_KEYS.DELETE_IMAGE)}</h6>
        <div className='row justify-content-center align-items-center'>
          <div className='mt-4 mx-3 col-5'>
            <NeoButton type='button' mode='newDesign' text={t(DIALOG_KEYS.YES)} onClick={deleteProfileImage} />
          </div>
          <div className='mt-4 mx-1 col-5'>
            <button
              type='button'
              onClick={hideDeleteModal}
              className='btn btn-sm btn-link small new-design-warning-text-color font-weight-600'>
              {t(DIALOG_KEYS.NO)}
            </button>
          </div>
        </div>
      </Modal>
    ),
    [],
  )

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderProfile()

      default:
        return renderProfile()
    }
  }
  const updateProfileImage = useCallback(
    async (imgData) => {
      setLoading(true)
      try {
        const response = await AuthService.updateUserProfileImage(imgData)
        if (response.status === 200) {
          setMessage(response.data['message'])
          setLoading(false)
          showSuccessModal()
        }
      } catch (err) {
        setLoading(false)
        showSuccessModal()
      }
    },
    [inputFile],
  )

  const handleFileRead = useCallback(
    async (e) => {
      const content = e.target.result
      await updateProfileImage(content.toString().split(',')[1])
    },
    [updateProfileImage],
  )

  useEffect(() => {
    const fileReader = new FileReader()
    fileReader.onloadend = handleFileRead
    imgLocation === '' ? '' : fileReader.readAsDataURL(imgLocation)
  }, [imgLocation, handleFileRead])

  const deleteProfileImage = useCallback(async () => {
    try {
      setLoading(true)
      hideDeleteModal()
      const response = await AuthService.deleteUserProfileImage()
      if (response.status === 200) {
        setLoading(false)
        setMessage(response.data['message'])
        showSuccessModal()
      }
    } catch (err) {
      setLoading(false)
    }
  }, [hideDeleteModal, showSuccessModal])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderProfile() {
    return (
      <div id='Profile' className='container-fluid h-100'>
        <div>
          <div className='mt-5 ml-4 d-flex justify-content-center'>
          <div className='profile-picture rounded-circle'>
            {loading ? (
              renderLoading()
            ) : (
              <img
                className='profile-picture rounded-circle'
                src={
                  profileImage === null ? UserImageIcon : `data:image/png;base64,${profileImage}`
                }
                alt=' Profile'
              />
            )}
            </div>
            {profileImage !== null && (
              <button
                type='button'
                onClick={deleteModal}
                className='btn btn-sm btn-link small new-design-warning-text-color font-weight-600'>
                <img src={DeleteIcon} />
              </button>
            )}
          </div>
          <div className='text-center mt-3'>
            <button
              type='button'
              ref={inputFile}
              onClick={() => {
                inputFile.current.click()
              }}
              className='btn btn-sm btn-link small new-design-warning-text-color font-weight-600'>
              <img src={UploadIcon} className='mr-2' />
             {t(PROFILE_KEYS.UPLOAD)}
            </button>
          </div>
          <input
            type='file'
            id='file'
            accept='image/png, image/jpeg, image/jpg'
            ref={inputFile}
            style={{ display: 'none' }}
            onChange={(e) => {
              var size = e.target.files[0].size / 1000
              if (size > 100) {
                setMessage(t(PROFILE_KEYS.UPLOAD_MESSAGE))
                e.target.value = null
                showSuccessModal()
                return
              }
              setImgLocation(e.target.files[0])
              e.target.value = null
            }}
          />
          <div className='row my-5 text-center'>
            <div className='col-11 mx-auto'>
              <h4 className='mb-4 font-weight-bold'>{profile.name}</h4>
              {config.CLIENT_NAME !== 'NBS' &&
                <>
                  <div className='row my-2 py-2'>
                    <div className='col-4 text-right border-right' style={{ fontSize: '10px' }}>
                      {t(PROFILE_KEYS.HOME_BRANCH)}
                    </div>
                    <div className='col-8 font-weight-bold  text-left' style={{ fontSize: '14px' }}>
                      {profileDetails?.branchName}
                    </div>
                  </div>
                  <div className='row my-2 py-2'>
                    <div className='col-4 text-right border-right' style={{ fontSize: '10px' }}>
                      {t(PROFILE_KEYS.brnCode)}
                    </div>
                    <div className='col-8 font-weight-bold text-left' style={{ fontSize: '14px' }}>
                      {profileDetails?.branchCode}
                    </div>
                  </div>
                </>
              }

              <div className='row my-2 py-2'>
                <div className='col-4 text-right border-right' style={{ fontSize: '10px' }}>
                {t(PROFILE_KEYS.DOB)}
                </div>
                <div className='col-8 font-weight-bold text-left' style={{ fontSize: '14px' }}>
                  {profileDetails?.customerDob}
                </div>
              </div>
              <div className='row my-2 py-2'>
                <div className='col-4 text-right border-right' style={{ fontSize: '10px' }}>
                  {t(PROFILE_KEYS.MOBILE)}
                </div>
                <div className='col-8 font-weight-bold text-left' style={{ fontSize: '14px' }}>
                  {profileDetails?.mobileNo}
                </div>
              </div>
              {config.CLIENT_NAME !== 'NBS' &&
                <div className='row my-2 py-2'>
                  <div className='col-4 text-right border-right' style={{ fontSize: '10px' }}>
                    {t(PROFILE_KEYS.COUNTRY_CODE)}
                  </div>
                  <div className='col-8 font-weight-bold text-left' style={{ fontSize: '14px' }}>
                    {profileDetails?.smscntryCode}
                  </div>
                </div>
              }
              <div className='row my-2 py-2'>
                <div className='col-4 text-right border-right' style={{ fontSize: '10px' }}>
                {t(PROFILE_KEYS.EMAIL)}
                </div>
                <div className='col-8 font-weight-bold  text-left' style={{ fontSize: '14px' }}>
                  {profileDetails?.emailId}
                </div>
              </div>
              <div className='row my-2 py-2'>
                <div className='col-4 text-right border-right' style={{ fontSize: '10px' }}>
                  {t(PROFILE_KEYS.ADDRESS)}
                </div>
                <div className='col-8 font-weight-bold  text-left' style={{ fontSize: '14px' }}>
                  {`${profileDetails?.add1 || ''} ${profileDetails?.add2 || ''} ${
                    profileDetails?.add3 || ''
                  }`}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard
      breadCumKey='PROFILE'
      keyPath={'PROFILE_SETTINGS'}
      showEmptySpace={true}>
      <div className='new-design-form-style' style={{ padding: '20px 36px !important' }}>
        <div className='heading-style'>{t(MENU_SIDEBAR_KEYS.PROFILE)}</div> {renderSwitch()}
      </div>
    </LayoutWithOutAccountCard>
  )
}
